import React, { FC, useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import TableTab from "../components/tabs/table-tab";
import { SCHEDULED_TOURS } from "../constants/menu-types";
import { useLocale } from "../contexts/localeContext";
import { TableContextProvider } from "../contexts/table/TableContextProvider";
import { TranslationKeys } from "../contexts/TranslationKeys";
import columns from '../models/ColumnDefinitions/TourRouteColumns';
import { Lookup } from "../models/Lookup";
import LookupTypes from "../models/LookupTypes";
import SiteSearch from "../models/search/SiteSearch";
import searchColumns from '../models/search/TourRouteSearch';
import { getSiteNamesWithPagination } from "../services/siteService";
import { getTourRoutes } from "../services/tourRouteService";

const TourRoutesTab: FC = () => {
    const { translate } = useLocale();
    const title = translate.byKey(TranslationKeys.tourRoutes);
    const [lookup, setLookup] = useState<Lookup[]>([]);
    const itemPath = '/access-control/modules/scheduled-tours/';

    useEffect(() => {
        setLookup([{
            name: LookupTypes.tourRouteSite,
            values: [],
            dataMethod: getSiteNamesWithPagination,
            searchAccessor: SiteSearch.find(item => item.accessor === "name")?.searchOnName
        }]);
    }, [])

    // user preference items
    const userLoginId = useSelector((state: any) => (state.userInfo.id))
    const initialiseUserPreferences = (setDetails: (userLoginId, SCHEDULED_TOURS) => void) => {
        setDetails(userLoginId, SCHEDULED_TOURS);
    }
    // <-- end context

    return (<TableContextProvider
        initialiser={(setDetails) => initialiseUserPreferences(setDetails)}
        dataMethod={getTourRoutes}
        tableDescriptor={columns}
        searchDescriptor={searchColumns}
        useFilter
        useSort
        usePagination
        useSearch
        useTable
        lookup={lookup}
        showAddNewButton={false}>
        <TableTab
            title={title}
            selectRows={false}
            rowPath={itemPath}
            cyName="tourRoutes"
        />
    </TableContextProvider >
    ); 
};

export default TourRoutesTab;
